import { environment } from '../../environments/environment';

export const locale = {
    lang: 'en',
    data: {
        APP: {
            TITLE: environment.titleBase,
            SOCKET: {
                DISCONNECT: 'You have been disconnected',
                OFFLINE: 'You have no internet connection',
                RECONNECTING: 'Reconnecting...',
                RECONNECT: 'Reconnect',
            },
            PUSH_NOTIFICATION: {
                REQUEST_PERMISSION: {
                    TITLE: 'Enable Notifications',
                    MESSAGE: 'Enable browser notifications to receive alerts.',
                },
                BUTTONS: {
                    ALLOW: 'Enable',
                    CANCEL: 'Cancel',
                },
            },
            MODAL: {
                FEATURES: {
                    TITLE: "What's New",
                    BUTTONS: {
                        READ_LATER: 'Read Later',
                        OK: 'OK, Got It',
                        READ_ALL: 'Read All',
                    },
                },
                SEARCH_ORDER: {
                    TITLE: 'Search Order',
                    BUTTONS: {
                        SEARCH: 'Search',
                        CANCEL: 'Cancel',
                    },
                },
                PEOPLE: {
                    TITLE: 'Search person',
                    BUTTONS: {
                        CANCEL: 'Cancel',
                    },
                },
                CHUNK_ERROR: {
                    TITLE: 'System Update',
                    DESCRIPTION: 'A new version of the system is available. Please reload the page to update.',
                    BUTTONS: {
                        CONFIRM: 'Reload',
                    },
                },
                LABORATORY_CHANGED: {
                    TITLE: 'Session changed',
                    DESCRIPTION: 'We detected that the laboratory or logged-in account has changed.<br>Please reload the page to continue.',
                    BUTTONS: {
                        CONFIRM: 'Reload',
                    }
                }
            },
        },
    },
};
